/* Maps the activityFeed `reason` enum to a short suffix rendered after the
   username ("mintyfresh posted a clip"). Verified against the live schema,
   which exposes exactly these eight values. Anything unrecognized — including
   future reasons the backend adds — falls through to null, so the caller
   omits the suffix rather than showing filler text. */
export const ACTIVITY_FEED_REASON_LABELS: Record<string, string> = {
  FOLLOWING: "posted a clip",
  LAST_CLIP: "posted a clip",
  OWN_RECENT: "posted a clip",
  PROMOTED_COMPETITION_CLIP: "submitted a clip",
  CURRENT_COMPETITION: "Competition running",
  UPCOMING_COMPETITION: "Upcoming competition",
  COMPLETED_COMPETITION: "Competition ended",
};

/* A clip a promoted competition put in front of everyone, rather than one the
   viewer would have seen anyway. The card badges these with the competition
   name. */
export const PROMOTED_COMPETITION_CLIP = "PROMOTED_COMPETITION_CLIP";

export const getReasonLabel = (reason: string): string | null =>
  ACTIVITY_FEED_REASON_LABELS[reason] ?? null;
